import moment from 'moment';
import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
    getAllGroups,
    getAllFactoriesByGroupID,
    getPurchaseTypesForDropdown,
    getItemCategoryForDropDown,
    getItemByItemCategoryForDropDown,
    getDeliveryWarehousesForDropdownByID,
    GetSuppliersByGroupIDAndFactoryID,
    getSKUTypesForDropDown,
    generateRequisitionNumber,
    getAvailableQuantity,
    SaveRequisition,
    getRequisitionDetails,
    getDetailsByRequisitionID,
    updateRequisition,
    DeleteRequisitionItem,
    GetWarehousesByGroupIDAndFactoryID,
    DeleteRequisitionItemWithRequisition,
    approveRequisition,
    rejectRequisition,
    getBudgetCodeDetails,
    getStatusDetails,
    GetSKUCategoryNamesByID,
    getSKUMeasuringUnit,
    getUserDetailsByRequisitionNo
}

async function getAllGroups() {
    let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
    return groupArray;
}

async function getAllFactoriesByGroupID(groupID) {
    let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    const factoryArray = [];
    const data = response?.data ?? [];
    if (Array.isArray(data)) {
        for (const item of data) {
            factoryArray.push({
                id: item.factoryID,
                name: item.factoryName
            });
        }
    } else {
        for (const [, item] of Object.entries(data)) {
            factoryArray.push({
                id: item.factoryID,
                name: item.factoryName
            });
        }
    }
    return factoryArray;
}
async function getPurchaseTypesForDropdown() {
    let response = await CommonGet('/api/PurchaseType/GetAllPurchaseTypes', null);
    let purchaseTypesArray = []
    for (let item of Object.entries(response.data)) {
        purchaseTypesArray[item[1]["purchaseTypeID"]] = item[1]["purchaseTypeName"]
    }
    return purchaseTypesArray;
}

async function getItemCategoryForDropDown(groupID, estateID) {
    const response = await CommonGet('/api/Requisition/GetSKUCategories', 'groupID=' + parseInt(groupID) + '&estateID=' + parseInt(estateID));
    let skuCategoryArray = []
    for (let item of Object.entries(response.data)) {
        skuCategoryArray[item[1]["skuCategoryID"]] = item[1]["skuCategoryName"]
    }
    return skuCategoryArray;
}

async function getItemByItemCategoryForDropDown(budgetCode, itemCategory, factoryID) {
    const response = await CommonGet('/api/Requisition/GetSKUItems', 'itemCategory=' + parseInt(itemCategory) + '&budgetCode=' + parseInt(budgetCode) + '&factoryID=' + parseInt(factoryID));
    let skuItemArray = [];
    for (let item of response.data) {
        skuItemArray.push({
            skuMappingID: item.skuMappingID,
            skuMasterName: item.skuMasterName
        });
    }
    return { skuItemArray, response };


}

async function getDeliveryWarehousesForDropdownByID(SKUMappingID) {
    const response = await CommonGet('/api/WarehouseSKUMapping/GetDeliveryWarehousesForDropdownByID', 'skuMappingID=' + parseInt(SKUMappingID));
    let deliveryWarehouseArray = []
    for (let item of Object.entries(response.data)) {
        deliveryWarehouseArray[item[1]["deliveryWarehouseID"]] = item[1]["deliveryWarehouseName"]
    }
    return deliveryWarehouseArray;
}

async function getSKUTypesForDropDown() {
    const response = await CommonGet('/api/Requisition/GetSKUTypes', null);
    let skuTypeArray = []
    for (let item of Object.entries(response.data)) {
        skuTypeArray[item[1]["skuTypeID"]] = item[1]["skuTypeName"]
    }
    return skuTypeArray;
}

async function getSKUMeasuringUnit(skuID) {
    const response = await CommonGet('/api/Requisition/getSKUMeasuringUnit', 'skuID=' + parseInt(skuID));
    return response;
}

async function GetSuppliersByGroupIDAndFactoryID(groupID, estateID) {
    const response = await CommonGet('/api/Requisition/GetSKUFields', 'groupID=' + groupID + '&estateID=' + estateID)
    let skuFields = []
    for (let item of Object.entries(response.data)) {
        skuFields[item[1]["fieldID"]] = item[1]["fieldName"]
    }
    return skuFields;
}

async function GetWarehousesByGroupIDAndFactoryID(groupID, estateID) {
    const response = await CommonGet('/api/Requisition/GetWarehouseID', 'groupID=' + groupID + '&estateID=' + estateID)
    let wareHouses = []
    for (let item of Object.entries(response.data)) {
        wareHouses[item[1]["warehouseID"]] = item[1]["warehouseName"]
    }
    return wareHouses;
}

async function GetSKUCategoryNamesByID(budgetCodeID, groupID) {
    let response = await CommonGet('/api/SKUCategory/GetSKUCategoryNamesByEstateIDBudgetCodeID', 'budgetCodeID=' + budgetCodeID + '&groupID=' + groupID);
    let categoryArray = [];
    for (let item of response.data) {
        categoryArray.push({
            skuCategoryID: item.skuCategoryID,
            skuCategoryName: item.skuCategoryName
        });
    }
    return categoryArray;
}

async function getBudgetCodeDetails() {
    let response = await CommonGet('/api/BudgetCode/GetAllBudgetCodes', null);
    let budgetCodeArray = [];
    for (let item of Object.entries(response.data)) {
        budgetCodeArray[item[1]["budgetCodeID"]] = item[1]["budgetCodeName"];
    }
    return budgetCodeArray;
};

async function getStatusDetails() {
    let response = await CommonGet('/api/Requisition/getStatusDetails', null);
    let statusArray = [];
    for (let item of Object.entries(response.data)) {
        statusArray[item[1]["statusID"]] = item[1]["statusName"];
    }
    return statusArray;
};

async function SaveRequisition(genaralModel, gridDatArray) {
    let saveModel = {
        groupID: parseInt(genaralModel.groupID),
        factoryID: parseInt(genaralModel.factoryID),
        budgetCodeID: parseInt(genaralModel.budgetCodeID),
        requisitionNumber: genaralModel.requisitionNumber,
        requestDate: genaralModel.requestDate,
        expectedDate: genaralModel.expectedDate,
        isUrgent: genaralModel.isUrgent,
        statusTypeID: parseInt(genaralModel.statusTypeID),
        createdBy: genaralModel.createdBy,
        requisitionDetails: gridDatArray
    }

    const response = await CommonPost('/api/Requisition/SaveRequisition', null, saveModel);
    return response;
}

async function getRequisitionDetails(model) {
    const response = await CommonPost('/api/Requisition/getRequisitionDetails', null, model);
    return response;
}

async function getDetailsByRequisitionID(requisitionID) {
    const response = await CommonGet('/api/Requisition/getDetailsByRequisitionID', 'requisitionID=' + parseInt(requisitionID));
    return response;
}

async function getUserDetailsByRequisitionNo(requisitionNo) {
    const response = await CommonGet('/api/Requisition/getUserDetailsByRequisitionNo', 'requisitionNo=' + requisitionNo);
    return response;
}

async function generateRequisitionNumber(groupID, factoryID, date) {
    const requestdate = moment(date.toString()).format('').split('T')[0]
    const response = await CommonPost('/api/Requisition/generateRequisitionNumber', 'groupID=' + parseInt(groupID) + '&factoryID=' + parseInt(factoryID) + '&requestDate=' + requestdate);
    return response;
}
async function getAvailableQuantity(groupID, factoryID, skuCategoryID, skuMasterID) {
    const response = await CommonPost('/api/Requisition/getAvailableQuantity', 'groupID=' + parseInt(groupID) + '&factoryID=' + parseInt(factoryID) + '&skuCategoryID=' + parseInt(skuCategoryID) + '&skuMasterID=' + parseInt(skuMasterID));
    return response;
}

async function updateRequisition(updateModel) {
    const response = await CommonPost('/api/Requisition/updateRequisition', null, updateModel);
    return response;
}

async function DeleteRequisitionItem(deleteModel) {
    const response = await CommonPost('/api/Requisition/DeleteRequisitionItem', null, deleteModel);
    return response;
}


async function DeleteRequisitionItemWithRequisition(deleteModel) {
    const response = await CommonPost('/api/Requisition/DeleteRequisitionItemWithRequisition', null, deleteModel);
    return response;
}

async function approveRequisition(requisitionID, createdBy, requisitionStatus) {
    const response = await CommonPost('/api/Requisition/approveRequisition', 'requisitionID=' + parseInt(requisitionID) + '&createdBy=' + createdBy + '&requisitionStatus=' + parseInt(requisitionStatus));
    return response;
}

async function rejectRequisition(requisitionID, createdBy) {
    const response = await CommonPost('/api/Requisition/rejectRequisition', 'requisitionID=' + parseInt(requisitionID) + '&createdBy=' + createdBy);
    return response;
}